import { render, staticRenderFns } from "./home-modal.vue?vue&type=template&id=2fd295e8&"
import script from "./home-modal.vue?vue&type=script&lang=ts&"
export * from "./home-modal.vue?vue&type=script&lang=ts&"
import style0 from "./home-modal.vue?vue&type=style&index=0&id=2fd295e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports